import Vue from 'vue'
import App from './App.vue'
import router from './router'

import {Lazyload, Notify, Toast} from 'vant';

// import "./assets/coupon-gradient.svg";
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(Lazyload);
Vue.use(Toast);
Vue.use(Notify);
Vue.use(VueCookies);

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
